import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { UncontrolledTooltip, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import handleValidDate from "../../../helpers/utils/handleValidDate";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetEmployeeState, getEmployee } from "../../../store/employee/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { resetEmployeeContractTypeState, getEmployeeContractType } from "../../../store/employeeContractType/action";
import { getEmployeeContract as onGetEmployeeContracts, addNewEmployeeContract as onAddNewEmployeeContract, updateEmployeeContract as onUpdateEmployeeContract, deleteEmployeeContract as onDeleteEmployeeContract, getEmployeeContractLoading } from "../../../store/employeeContract/action";
import "react-toastify/dist/ReactToastify.css";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";
import imgNotFound from "../../../assets/images/users/img-remove.png";
import { api } from "../../../config";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { ButtonPrint, PrintDoc } from "./PrintDoc";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const EmployeeContract = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const printRef = useRef(null);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, companies, companyLoading, clients, clientLoading, employeeContracts, isEmployeeContractCreated, isEmployeeContractSuccess, loading, error, employees, employeeLoading, positions, positionLoading, employeeContractTypes, employeeContractTypeLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    employeeContracts: state.EmployeeContract.employeeContracts,
    isEmployeeContractCreated: state.EmployeeContract.isEmployeeContractCreated,
    isEmployeeContractSuccess: state.EmployeeContract.isEmployeeContractSuccess,
    loading: state.EmployeeContract.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    employeeContractTypes: state.EmployeeContractType.employeeContractTypes,
    employeeContractTypeLoading: state.EmployeeContractType.loading,
    error: state.EmployeeContract.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
  }));

  const [employeeContractList, setEmployeeContractList] = useState([]);
  const [employeeContract, setEmployeeContract] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [positionList, setPositionList] = useState([]);
  const [employeeContractTypeList, setEmployeeContractTypeList] = useState([]);
  const [isPermanent, setIsPermanent] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [printDoc, setPrintDoc] = useState([]);

  const onClickDelete = (employeeContract) => {
    setEmployeeContract(employeeContract);
    setDeleteModal(true);
  };

  const handleDeleteEmployeeContract = () => {
    if (employeeContract) {
      dispatch(onDeleteEmployeeContract(employeeContract));
      setDeleteModal(false);
    }
  };

  const onClickApprove = (employee) => {
    setEmployeeContract(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(employeeContracts)) {
      let filteredEmployeeContracts = employeeContracts;
      if (activeTypeTab !== "all") {
        filteredEmployeeContracts = employeeContracts.filter((employeeContract) => employeeContract.contract_status.name === activeTypeTab);
      }
      setEmployeeContractList(filteredEmployeeContracts.map((el) => ({ ...el, isChecked: false })));
    }
    else {
      setEmployeeContractList([]);
    }
  }, [employeeContracts]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "contract_user",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Kode",
        isSelected: true,
        data: [],
      },
      {
        id: "contract_position",
        label: "Jabatan",
        isSelected: true,
        data: [],
      },
      {
        id: "contract_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
      {
        id: "contract_type",
        label: "Type Kontrak",
        isSelected: true,
        data: [],
      },
      {
        id: "startat",
        label: "Tanggal Mulai",
        isSelected: true,
        data: [],
      },
      {
        id: "endat",
        label: "Tanggal Berakhir",
        isSelected: true,
        data: [],
      },
    ];

    if (employeeContractList.length > 0) {
      employeeContractList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "contract_position" || doc.id === "contract_company" || doc.id === "contract_type" || doc.id === "contract_user") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "startat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "endat") {
                const endAt = data.contract_type && data.contract_type.type === "period" ? handleValidDate(value) : "-";
                doc.data.push(endAt);
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [employeeContractList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredEmployeeContracts = employeeContracts;
      if (type !== "all") {
        filteredEmployeeContracts = employeeContracts.filter((employeeContract) => employeeContract.contract_status.name === type);
      }
      setEmployeeContractList(filteredEmployeeContracts);
    }
  };

  useEffect(() => {
    if (companySelected && companySelected.value) {
      dispatch(onGetEmployeeContracts({ companyId: companySelected.value }));
      handleGetEmployee(companySelected.value);
      handleGetPosition(companySelected.value);
      handleGetEmployeeContractType(companySelected.value);
    }
  }, [companySelected]);

  const handleGetEmployee = (id) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: id }));
  };

  const handleGetPosition = (id) => {
    dispatch(resetPositionState());
    dispatch(getPosition({ companyId: id }));
  };

  const handleGetEmployeeContractType = (id) => {
    dispatch(resetEmployeeContractTypeState());
    dispatch(getEmployeeContractType({ companyId: id }));
  };

  useEffect(() => {
    if (!isEmpty(employeeContracts)) {
      setEmployeeContractList(employeeContracts);
      setInfo(employeeContracts[employeeContracts.length - 1]);
    }
  }, [employeeContracts]);

  const [filterDate, setFilterDate] = useState(null);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleEmployeeContractClick = useCallback(
    (arg) => {
      const data = arg;
      if (data.contract_type.type === "period") {
        setIsPermanent(true);
      } else {
        setIsPermanent(false);
      }

      setEmployeeContract({
        id: data.id,
        startat: data.startat,
        endat: data.endat,
        description: data.description,
        rates: data.rates,
        employee: data.contract_user &&
          data.contract_user.user_employee && {
          label: data.contract_user.user_employee ? data.contract_user.user_employee.name : "",
          value: data.contract_user.user_employee ? data.contract_user.user_employee.id : "",
          userId: data.contract_user.user_employee ? data.contract_user.user_employee.userId : "",
        },
        company: data.contract_company && {
          label: data.contract_company ? data.contract_company.name : "",
          value: data.contract_company ? data.contract_company.id : "",
        },
        client: data.contract_client && {
          label: data.contract_client ? data.contract_client.name : "",
          value: data.contract_client ? data.contract_client.id : "",
        },
        position: data.contract_position && {
          label: data.contract_position.name,
          value: data.contract_position.id,
          departmentId: data.contract_position.position_department ? data.contract_position.position_department.id : "",
        },
        contractType: data.contract_type && {
          label: data.contract_type ? data.contract_type.name : "",
          value: data.contract_type ? data.contract_type.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, dispatch, userType]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = employeeContractList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setEmployeeContractList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = employeeContractList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setEmployeeContractList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateEmployeeContract") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleEmployeeContractClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteEmployeeContract") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>

                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveEmployeeContract") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui kontrak pekerjaan untuk ${data.contract_user.user_employee.name} #${data.code}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                  {data.statusId === 3 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveEmployeeContract") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui kontrak pekerjaan untuk ${data.contract_user.user_employee.name} #${data.code}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>AKTIVASI
                    </button>
                  )}
                  <DropdownToggle tag="button" className={userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("updateEmployeeContract") !== -1 ? "btn btn-sm btn-light" : "btn btn-sm btn-light d-none"} split></DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={() => {
                        setInfo(data);
                        toggleDetail();
                      }}
                    >
                      PRINT SURAT PERJANJIAN KERJA KONTRAK
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "contract_user.name",
        filterable: true,
      },
      {
        Header: "Kode",
        accessor: "code",
        filterable: true,
      },
      {
        id: "Jabatan",
        Header: "Jabatan",
        accessor: "contract_position.name",
        filterable: true,
      },
      {
        id: "Perusahaan",
        Header: "Perusahaan",
        accessor: "contract_company.name",
        filterable: true,
      },
      {
        Header: "Tipe Kontrak",
        accessor: "contract_type.name",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div>
              <p className="mb-0 fw-semibold">{data.contract_position && data.contract_position.name}</p>
              <p className="mb-0">{data.contract_type.name}</p>
              <p className="mb-0">{data.contract_company.name}</p>
            </div>
          );
        },
      },
      {
        Header: "Tanggal Mulai",
        accessor: "startat",
        filterable: true,
        Cell: (client) => <>{handleValidDate(client.row.original.startat)}</>,
      },
      {
        Header: "Tanggal Berakhir",
        accessor: "endat",
        filterable: true,
        Cell: (client) => <>{client.row.original.contract_type && client.row.original.contract_type.type === "period" ? handleValidDate(client.row.original.endat) : "-"}</>,
      },
      {
        Header: "Status",
        accessor: "contract_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [employeeContractList, handleEmployeeContractClick, userType, userRole, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = employeeContractList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setEmployeeContractList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => employeeContractList, [employeeContractList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Jabatan", "Perusahaan"],
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  const handleApproveEmployee = () => {
    if (employeeContract) {
      employeeContract.setApprove = true;
      dispatch(onUpdateEmployeeContract(employeeContract));
      setApproveModal(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(employeeContractTypes)) {
      var data = [];
      var opt = [];
      employeeContractTypes.forEach((item, key) => {
        const contract_name = item.name;
        const id = item.id;
        var obj = { label: contract_name, value: id, type: item.type };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setEmployeeContractTypeList(data);
    }
  }, [employeeContractTypes]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    employees.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const userId = item.userId;
      var obj = { label: name, value: id, userId: userId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (employees.length > 0) {
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(positions)) {
      var data = [];
      var opt = [];
      positions.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const departmentId = item.departmentId;
        var obj = { label: name, value: id, departmentId: departmentId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPositionList(data);
    }
  }, [positions]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      startat: (employeeContract && employeeContract.startat) ?? "",
      endat: (employeeContract && employeeContract.endat) || moment().add(20, "years").format("YYYY/MM/DD").toString(),
      rates: (employeeContract && employeeContract.rates) ?? "",
      description: (employeeContract && employeeContract.description) ?? "",
      client: (employeeContract && employeeContract.client) || clientSelected,
      company: (employeeContract && employeeContract.company) || companySelected,
      employee: (employeeContract && employeeContract.employee) ?? "",
      position: (employeeContract && employeeContract.position) ?? "",
      contractType: (employeeContract && employeeContract.contractType) ?? "",
    },
    validationSchema: Yup.object({
      rates: Yup.string().required("Please Enter Pay Rate").nullable(true),
      employee: Yup.object().required("Please Pick Employee").nullable(true),
      position: Yup.object().required("Please Pick Position").nullable(true),
      contractType: Yup.object().required("Please Pick Contract Type").nullable(true),
      startat: Yup.string().required("Please Enter Subscription Date").nullable(true),
      endat: Yup.string().required("Please Enter Expired Date").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getEmployeeContractLoading());
      if (isEdit) {
        const updateEmployeeContract = {
          id: employeeContract ? employeeContract.id : 0,
          startat: values.startat,
          endat: values.endat,
          rates: values.rates,
          description: values.description,
          statusId: 1,
          clientId: values.client.value,
          companyId: values.company.value,
          departmentId: values.position.departmentId,
          userId: values.employee.userId,
          contractTypeId: values.contractType.value,
          positionId: values.position.value,
        };
        dispatch(onUpdateEmployeeContract(updateEmployeeContract));
        validation.resetForm();
      } else {
        const newEmployeeContract = {
          startat: values.startat,
          endat: values.endat,
          rates: values.rates,
          description: values.description,
          statusId: 1,
          clientId: values.client.value,
          companyId: values.company.value,
          departmentId: values.position.departmentId,
          userId: values.employee.userId,
          contractTypeId: values.contractType.value,
          positionId: values.position.value,
        };
        dispatch(onAddNewEmployeeContract(newEmployeeContract));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteEmployeeContract(element.value));
    });
    checkall.checked = false;
  };

  function handleEmployeeContractStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected.value ?? "",
    };
    dispatch(onGetEmployeeContracts(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setEmployeeContractList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(onGetEmployeeContracts({ companyId: companySelected.value }));
  };

  document.title = "Kontrak | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={employeeContractList} />
      <ApproveModal data={employeeContract && employeeContract.contract_employee ? employeeContract.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteEmployeeContract} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Karyawan" pageTitle="Kontrak" loading={loading}>
          <div className="flex-shrink-0">
            <div className="flex-shrink-0">
              <button
                type="button"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createEmployeeContract") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
                id="create-btn"
                onClick={() => {
                  setIsEdit(false);
                  toggle();
                }}
              >
                <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
              </button>
              {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger me-2" : userRole && userRole.split(",").indexOf("deleteEmployeeContract") !== -1 ? "btn btn-soft-danger me-2" : "d-none"} onClick={() => setDeleteModalMulti(true)}>
                <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
              </button> */}
              <ExportDoc data={printDoc} />
            </div>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={9}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA KONTRAK
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  handleEmployeeContractStatus(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Kontrak" : "Tambah Kontrak"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                // setCompanyList([]);
                                // validation.setFieldValue("company", "");
                                validation.setFieldValue("client", e);
                                // handleGetCompany(e.value);
                              }}
                              options={clientList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                                // handleGetEmployee(e.value);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="employee-field" className="form-label">
                              Karyawan <span className="text-danger">*</span>&nbsp;
                              {employeeLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="employee"
                              value={validation.values.employee}
                              placeholder="Pilih Karyawan"
                              isDisabled={employeeList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("employee", e);
                              }}
                              options={employeeList}
                            ></Select>
                            {validation.touched.employee && validation.errors.employee && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validation.errors.employee}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="position" className="form-label">
                              Posisi
                              {positionLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="position"
                              value={validation.values.position}
                              placeholder="Pilih Posisi"
                              onChange={(e) => {
                                validation.setFieldValue("position", e);
                              }}
                              options={positionList}
                              invalid={validation.touched.position && validation.errors.position ? true : false}
                            ></Select>
                            {validation.touched.position && validation.errors.position && (
                              <p className="text-danger" type="invalid">
                                {validation.errors.position}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="contractType" className="form-label">
                              Tipe Kontrak
                              {employeeContractTypeLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="contractType"
                              value={validation.values.contractType}
                              placeholder="Pilih Tipe Kontrak"
                              onChange={(e) => {
                                validation.setFieldValue("contractType", e);
                                if (e.type === "period") {
                                  setIsPermanent(true);
                                } else setIsPermanent(false);
                              }}
                              options={employeeContractTypeList}
                              invalid={validation.touched.contractType && validation.errors.contractType ? true : false}
                            ></Select>
                            {validation.touched.contractType && validation.errors.contractType && (
                              <p className="text-danger" type="invalid">
                                {validation.errors.contractType}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="reason-field" className="form-label">
                              Tarif
                            </Label>
                            <Input name="rates" id="rates-field" className="form-control" placeholder="Isi Tarif" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.rates ?? ""} invalid={validation.touched.rates && validation.errors.rates ? true : false} />
                            {validation.touched.rates && validation.errors.rates ? <FormFeedback type="invalid">{validation.errors.rates}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="date-field" className="form-label">
                              Tanggal Mulai
                            </Label>
                            <Flatpickr
                              name="startat"
                              className="form-control"
                              placeholder="Pilih Tanggal"
                              options={{ enableTime: false, dateFormat: "Y/m/d" }}
                              value={validation.values.startat ?? ""}
                              onChange={(o, e) => {
                                validation.setFieldValue("startat", e);
                              }}
                            />
                            {validation.touched.startat && validation.errors.startat && (
                              <p className="text-danger" type="invalid">
                                {validation.errors.startat}
                              </p>
                            )}
                          </div>
                          {!!isPermanent && (
                            <div className="mb-3">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Berakhir
                              </Label>
                              <Flatpickr
                                name="endat"
                                className="form-control"
                                placeholder="Select end date"
                                options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                value={validation.values.endat ?? ""}
                                onChange={(o, e) => {
                                  validation.setFieldValue("endat", e);
                                }}
                              />
                              {validation.touched.endat && validation.errors.endat && (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.endat}
                                </p>
                              )}
                            </div>
                          )}
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" rows={3} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Batal
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={3}>
            <Card>
              <CardBody className="text-center">
                <div className="position-relative d-inline-block">
                  <div className="avatar-md">
                    <div className="avatar-title bg-light rounded-circle">
                      {info.contract_user && info.contract_user.image !== "" ? (
                        <img
                          src={api.MEDIA_URL + "/media/" + info.contract_user.image}
                          alt=""
                          className="avatar-xs rounded-circle me-1"
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src = imgNotFound;
                          }}
                        />
                      ) : (
                        <img src={defaultImg} alt="" className="avatar-sm rounded-circle object-cover" />
                      )}
                    </div>
                  </div>
                </div>
                <h5 className="mt-2 mb-2">{info.contract_user && info.contract_user.name ? info.contract_user.name : ""}</h5>
              </CardBody>
              <div className="card-body">
                <h6 className="text-muted text-uppercase fw-semibold mb-2">Informasi Kontrak</h6>
                <p className="text-muted mb-4">{info.description && info.description ? info.description : "-"} </p>
                <div className="table-card p-2">
                  <table className="table table-responsive table-striped">
                    <tbody>
                      <tr>
                        <td className="p-2">Kontrak</td>
                        <td className="p-2">{info.contract_type && info.contract_type.name ? info.contract_type.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2"> Perusahaan</td>
                        <td className="p-2">{info.contract_company && info.contract_company.name ? info.contract_company.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Tanggal</td>
                        <td className="p-2">{info.startat && info.endat ? handleValidDate(info.startat) + " - " + handleValidDate(info.endat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Departemen </td>
                        <td className="p-2">{info.contract_position && info.contract_position.position_department && info.contract_position.position_department.name ? info.contract_position.position_department.name : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Jabatan</td>
                        <td className="p-2">{info.contract_position && info.contract_position.name ? info.contract_position.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Dibuat Oleh</td>
                        <td className="p-2">{info.contract_createdby && info.contract_createdby.name ? info.contract_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Diedit Oleh</td>
                        <td className="p-2">{info.contract_updatedby && info.contract_updatedby.name ? info.contract_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Disetujui Oleh</td>
                        <td className="p-2">{info.contract_approvedby && info.contract_approvedby.name ? info.contract_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
        <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
          {`VIEW SURAT PERJANJIAN KERJA KONTRAK`}
        </ModalHeader>
        {info !== undefined && info !== null && (
          <>
            <PrintDoc innerRef={printRef} item={info} />
          </>
        )}

        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => {
                setModalDetail(false);
              }}
            >
              TUTUP
            </button>
            {<ButtonPrint innerRef={printRef} title={`Surat-Perjanjian-Kerja-Kontrak-${info?.nama ?? ""}`} />}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EmployeeContract;
